import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_MODULE } from '../../../../Constants';

export const useUpdateModuleCertification = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateModuleCertificationHook = async (moduleUUID, certificationMetaData, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_MODULE}/${moduleUUID}/certificate/metadata`,
        {certificationMetaData}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to update module certificate");
      }
      
    } catch (error) {
      setError("An error occurred while updating the module certificate");
    } finally {
      setLoading(false);
    }
  };

  return [ updateModuleCertificationHook, loading, error, success ];
};